<template>
  <div>
    <v-card-title class="pa-1">
      <v-row>
        <v-col cols="6" class="pa-2">
          {{ model.id ? this.$t('message.product.updateProduct') : this.$t('message.product.addProduct') }}
        </v-col>
        <v-col cols="6" class="pa-2 text-right" v-if="copyProduct && copyProduct.isshow && model.ispackage">
          <v-btn small icon text color="primary" @click="copyConfirmation.click"><v-icon>mdi-content-copy</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-form ref="validateForm" autocomplete="off">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-1">
            <v-text-field outlined :hide-details="!productNumberError" :error-messages="productNumberError ? 'Number already exists!' : ''" @change="checkAvailability" :rules="$_requiredValidation" v-model="model.number" :label="$t('message.product.number')" dense></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="3" class="pa-1">
            <v-text-field outlined hide-details :rules="$_requiredValidation" v-model="model.name" :label="$t('message.customer.name')" dense @change="changesMade"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="1" class="pa-1">
            <v-select outlined dense :items="listOfTypes" :rules="$_requiredValidation" v-model="model.type" item-text="text" item-value="value" hide-details :label="$t('message.product.type')" @change="changesMade"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-1">
            <v-autocomplete outlined dense :items="list.groups" @change="$emit('gross-margin'), changesMade" autocomplete="off" v-model="model.productgroupid" :item-text="(x) => `${x.number ? x.number + ' - ' : ''} ${x.name}`" item-value="id" hide-details :label="$t('message.user.group')"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-1" v-if="isWorkType">
            <v-text-field outlined hide-details label="HS" v-model="model.hs" dense @change="changesMade"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-1" v-if="isWorkType">
            <v-text-field outlined hide-details label="COO" v-model="model.coo" dense @change="changesMade"></v-text-field>
          </v-col>

          <!-- <v-col cols="12" sm="6" md="3" lg="2" class="pa-1">
            <v-text-field outlined hide-details :label="$t('message.product.barcode')" v-model="model.barcode" dense @change="changesMade"></v-text-field>
          </v-col> -->
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-1">
            <v-autocomplete outlined hide-details dense :no-data-text="$t('message.common.no_records')" :items="listOfOperationTypes" :label="$t('message.products.operation_type')"
            item-text="name" clearable @click:clear="$nextTick(() => model.operation_type = '')" item-value="id" v-model="model.operation_type">
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-1">
            <v-select outlined dense :items="list.workflows" @click:clear="$nextTick(() => model.workflow_id = 0)" clearable :item-text="$i18n.locale === 'en' ? 'en_name' : 'no_name'" v-model="model.workflow_id" item-value="id" hide-details :label="$t('message.layout.workFlow')" @change="changesMade"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-1" v-if="!showBatch">
            <v-text-field outlined hide-details :label="$t('message.settings.prefixForwin')" v-model="model.win_prefix" dense @change="changesMade"></v-text-field>
          </v-col>
          <!-- <v-col cols="12" sm="6" md="3" lg="2" class="pa-1">
            <v-select outlined dense :items="list.departments" item-text="name" clearable v-model="model.department_id" item-value="id" hide-details :label="$t('message.stocks.department')" @change="changesMade"></v-select>
          </v-col> -->
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-1">
            <v-select outlined dense :items="list.productClasses" item-text="noname" v-model="model.ProductClassId" item-value="id" hide-details :label="$t('message.report.productClass')" @change="changesMade"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2" lg="1" class="pa-1 pt-0">
            <v-checkbox dense hide-details color="primary" v-model="model.isactive" :label="$t('message.common.isActive')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="1" class="pa-1 pt-0" v-if="isWorkType">
            <v-checkbox dense hide-details color="primary" v-model="model.stockitem" :label="$t('message.product.isStockItem')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-1 pt-0" v-if="isWorkType">
            <v-checkbox dense hide-details color="primary" v-model="model.certificaterequired" :label="$t('message.product.certificateReq')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="1" class="pa-1 pt-0">
            <v-checkbox dense hide-details color="primary" :readonly="isPackageHaveItems" v-model="model.ispackage" :label="$t('message.product.isPackage')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="1" class="pa-1 pt-0">
            <v-checkbox dense hide-details color="primary" v-if="showBatch" v-model="model.batchrequired" :label="$t('message.product.batchOrWIN')" @change="changesMade"></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="10" cols="12">
            <v-row>
              <v-col>
                <v-subheader class="pl-0 font-weight-bold body-1 mb-n4">{{ $t('message.product.prices') }}:</v-subheader>
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col cols="12" sm="6" md="2" lg="2" class="pa-1">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation"
                  v-model="model.costprice" :label="$t('message.product.costPrice')" :readonly="isWorkType" @change="calculateSalesValue" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="2" class="pa-1">
                <v-text-field outlined hide-details :rules="$_norwegianNumberMinusValidation" @change="calculateSalesValue" v-model="model.grosmargin" :label="$t('message.product.grossMargin')" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="2" class="pa-1">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" @change="calculateGrosMarginValue" v-model="model.salesprice" :label="$t('message.product.salePriceExVat')" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="2" class="pa-1">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" @change="salesPriceHandler('salesprice', 'salespriceincvat', 2)" v-model="model.salespriceincvat" :label="$t('message.product.salePriceIncVat')" dense></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="2" lg="2" class="pa-2">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.baseprice" :label="$t('message.product.basePrice')" dense></v-text-field>
              </v-col> -->
              <v-col cols="12" sm="6" md="3" lg="2" class="pa-2">
                <v-menu :close-on-content-click="false" v-model="model.priceValidMenu" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined hide-details dense clearable :label="$t('message.product.priceValidFrom')" prepend-icon="event"
                    readonly v-on="on" v-model="model.pricevalidfrom" :rules="$_requiredValidation"
                    @click:clear="$nextTick(() => model.priceValidFromPicker = null)"></v-text-field>
                  </template>
                  <v-date-picker color="primary" v-model="model.priceValidFromPicker" @input="model.priceValidMenu = false" first-day-of-week='1'></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="1" class="pa-1">
                <v-select outlined dense :items="listOfVAT" @change="salesPriceHandler('salespriceincvat', 'salesprice', 1)" :rules="$_selectRequiredValidation" v-model="model.vatid" item-text="text" item-value="value" hide-details :label="$t('message.customer.vatId')"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="1" class="pa-1">
                <v-select outlined dense :rules="$_requiredValidation" :items="list.sales_accounts" v-model="model.salesaccountid" item-text="accountnumber" item-value="id" hide-details :label="$t('message.product.salesAccount')"></v-select>
              </v-col>
            </v-row>
            <v-row v-if="showPriceUpdateText">
              <v-col cols="8" class="pt-0 pb-0 font-color">
                <h4>{{ $t('message.product.priceAdjustmentAdded') }}</h4>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" cols="12">
            <v-row class="py-1">
              <v-col>
                <v-subheader v-if="isWorkType" class="pl-0 mb-n4 font-weight-bold body-1">{{ $t('message.product.stocks') }}:</v-subheader>
                <v-divider v-if="isWorkType"></v-divider>
              </v-col>
            </v-row>
            <v-row v-if="isWorkType">
              <v-col cols="12" class="pa-1">
                <v-text-field outlined hide-details readonly v-model="model.available" :label="$t('message.product.available')" dense></v-text-field>
              </v-col>
              <!-- <v-col cols="12" xs="6" sm="4" md="2" lg="1" class="pa-1">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.minstock" :label="$t('message.product.minStock')" dense></v-text-field>
              </v-col>
              <v-col cols="12" xs="6" sm="4" md="2" lg="1" class="pa-1">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.orderqty" :label="$t('message.product.orderQty')" dense></v-text-field>
              </v-col> -->
            </v-row>
          </v-col>
        </v-row>
        <v-subheader v-if="isWorkType" class="pl-0 font-weight-bold body-1">{{ $t('message.product.unit') }}s:</v-subheader>
        <v-divider v-if="isWorkType" class="mb-2"></v-divider>
        <v-row>
          <v-col cols="8">
            <v-simple-table dense class="bordered--table elevation-1" :key="reInit">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td width="15%"> {{ $t('message.product.unit') }} </td>
                    <td width="12%">{{ $t('message.product.qty') }}</td>
                    <td width="12%">{{ $t('message.product.minQty') }}</td>
                    <td width="12%">{{ $t('message.product.orderQty') }}</td>
                    <td width="10%">{{ $t('message.product.salesUnit') }}</td>
                    <td width="10%">{{ $t('message.product.supplier') }}</td>
                    <td width="20%">{{ $t('message.product.ean') }}</td>
                    <td class="text-center">
                      <v-btn color="success" text fab dark small class="mt-n1" @click="addOrReomveProductUnit('PUSH')"> <v-icon dark>mdi-plus-circle</v-icon> </v-btn>
                    </td>
                  </tr>
                  <tr v-for="(unit, index) in model.units" :key="index">
                    <td class="pl-1 pr-1">
                      <!-- append-icon="add_circle"  @click:append="$emit('supportingList', PRODUCTUNITS, 'unitid')" -->
                      <v-select dense :items="list.units" item-text="name" autocomplete="off" :rules="$_requiredValidation" v-model="unit.unitid"
                        item-value="id" @click:clear="$nextTick(() => unit.unitid = null)" ref="unitid" hide-details @change="changesMade"></v-select>
                    </td>
                    <td class="pl-1 pr-1">
                      <v-text-field v-model="unit.qty" :rules="unit.qty ? $_norwegianNumberValidation : $_requiredValidation" dense hide-details></v-text-field>
                    </td>
                    <td class="pl-1 pr-1">
                      <v-text-field v-if="unit.issupplier" v-model="unit.minqty" :rules="$_norwegianNumberValidation" dense hide-details></v-text-field>
                    </td>
                    <td class="pl-1 pr-1">
                      <v-text-field v-if="unit.issupplier" v-model="unit.orderqty" :rules="$_norwegianNumberValidation" dense hide-details></v-text-field>
                    </td>
                    <td class="pl-1 pr-1">
                      <v-checkbox class="ml-8 pa-0 mt-0" color="primary" v-model="unit.issaleunit" hide-details dense @change="updateSaleUnitInList(index, unit.issaleunit)"></v-checkbox>
                    </td>
                    <td class="pl-1 pr-1">
                      <v-checkbox class="ml-8 pa-0 mt-0" color="primary" v-model="unit.issupplier" hide-details dense @change="reInit++"></v-checkbox>
                    </td>
                    <td class="pl-1 pr-1">
                      <v-text-field v-model="unit.ean" dense hide-details></v-text-field>
                    </td>
                    <td class="text-center pl-1 pr-1">
                      <v-btn icon text @click="addOrReomveProductUnit('POP', index)"> <v-icon color="error">mdi-delete</v-icon></v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row class="py-1">
          <v-col>
            <v-subheader v-if="isWorkType" class="pl-0 mb-n4 font-weight-bold body-1">{{ $t('message.product.measures') }}:</v-subheader>
            <v-divider v-if="isWorkType"></v-divider>
          </v-col>
        </v-row>
        <v-row v-if="isWorkType">
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.length" :label="$t('message.product.length')" dense></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.width" :label="$t('message.product.width')" dense></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.thickness" :label="$t('message.product.thickness')" dense></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.weight" :label="$t('message.product.weight')" dense></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.radius" :label="$t('message.product.radius')" dense></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.area" :label="$t('message.product.area')" dense></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.minlength" :label="$t('message.product.minLength')" dense></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.minwidth" :label="$t('message.product.minWidth')" dense></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.minthickness" :label="$t('message.product.minThickness')" dense></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.maxlength" :label="$t('message.product.maxLength')" dense></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.maxwidth" :label="$t('message.product.maxWidth')" dense></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="3" md="2" lg="1" class="pa-1">
            <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.maxthickness" :label="$t('message.product.maxThickness')" dense></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <template v-if="model.id && model.sharepoint_link">
        <v-subheader class="pl-0 font-weight-bold body-1">{{ $t('message.onedriveSettings.odLink') }}:</v-subheader>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12" class="pa-2">
            <label class="pa-2" ><a  target="_blank" :href="model.sharepoint_link">{{ model.sharepoint_link }}</a></label>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </div>
</template>
<script>
export default {
  props: {
    model: {
      type: Object
    },
    list: {
      type: Object
    },
    isWorkType: {
      type: Boolean
    },
    isPackageHaveItems: {
      type: Boolean
    },
    showPriceUpdateText: {
      type: Boolean
    },
    copyProduct: {
      type: Object
    },
    copyConfirmation: {
      type: Object
    }
  },
  data () {
    return {
      reInit: 0,
      productNumberError: false,
      showBatch: true
    }
  },
  mounted () {
    this.$eventBus.$on('deleteSuccess', (data) => {
      this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.deleteSuccess') })
      this.$store.commit('hideDialog')
      if (data === 'productunitmatrix') this.$eventBus.$emit('updateProductUnits')
    })
    this.$eventBus.$on('checkForWorkflow', () => {
      this.getWinPrefixField(this.model.workflow_id)
    })
  },
  watch: {
    'model.workflow_id' (value) {
      this.getWinPrefixField(value)
    }
  },
  computed: {
    listOfOperationTypes () {
      if (this.$store.state.workFlowStates && this.$store.state.workFlowStates.length > 0) {
        var getListOfOperationTypes = this.$store.state.workFlowStates.slice()
        getListOfOperationTypes.splice(0, 1)
        return getListOfOperationTypes
      } else return []
    },
    listOfTypes () {
      return [{
        text: this.$t('message.layout.product'),
        value: 'product'
      }, {
        text: this.$t('message.product.work'),
        value: 'work'
      }]
    },
    listOfVAT () {
      return [{
        text: '0%',
        value: 0
      }, {
        text: '12%',
        value: 12
      }, {
        text: '25%',
        value: 25
      }]
    }
  },
  methods: {
    calculateGrosMarginValue () {
      this.$eventBus.$emit('calculateGrosMarginValue')
    },
    calculateSalesValue () {
      this.$eventBus.$emit('calculateSalesValue')
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    },
    checkForNumberDuplication () {
      this.$eventBus.$emit('checkForNumberDuplication')
    },
    salesPriceHandler (target, field, type) {
      this.$eventBus.$emit('salesPriceHandler', { target, field, type })
    },
    checkAvailability () {
      this.changesMade()
      this.$_executeApi('get', `/products/is_productnumber_exists?id=${this.model.id || 0}&number=${this.model.number}`).then(response => {
        this.productNumberError = response.data
      })
    },
    addOrReomveProductUnit (type, index) {
      if (type === 'PUSH') {
        this.model.units.push({})
        this.reInit++
        // this.$set(this.model.units, this.model.units.length,  {})
      } else {
        if (this.model.units[index].id) {
          const payload = { ids: [this.model.units[index].id], url: 'productunitmatrix/delete_multiple', module: 'productunitmatrix' }
          this.$store.commit('showDeleteDialog', payload)
        } else {
          const self = this
          self.$store.commit('showDeleteDialog', {
            isLocalDelete: true,
            dialogOkCb: () => {
              self.model.units.splice(index, 1)
              self.reInit++
            }
          })
        }
      }
    },
    updateSaleUnitInList (index, value) {
      // eslint-disable-next-line
      this.model.units.map(x => x.issaleunit = false)
      if (value) this.model.units[index].issaleunit = true
      this.reInit++
    },
    getWinPrefixField (value) {
      var workflow = this.list.workflows.find(x => x.id === value)
      if (workflow?.is_generate_win) {
        this.showBatch = false
        this.$set(this.model, 'batchrequired', false)
      } else {
        this.showBatch = true
      }
      this.$set(this.model, 'win_prefix', workflow?.is_generate_win ? this.model.win_prefix ? this.model.win_prefix : 'NO-RTS3' : '')
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('checkForWorkflow')
  }
}
</script>
